import * as React from 'react';
import { createPortal } from 'react-dom';

interface Props {}

const head = document.head;

export const Head: React.FC<Props> = ({ children }) => {
  if (head) {
    return createPortal(children, head);
  }

  return null;
};
